/**
 * OneDrive Redux: all slices and thunks fired up from here.
 * Use full names (fetchOneDriveDocuments, deleteOneDriveDocument, etc.), not "on*" methods.
 */
import oneDriveListSlice from "./oneDriveListSlice";
import filteredOneDriveSlice from "./filteredOneDriveSlice";
import oneDriveDocsListReducer from "./oneDriveDocsListSlice";
import oneDriveDeleteSlice from "./oneDriveDeleteSlice";
import oneDriveDownloadReducer from "./oneDriveDownloadSlice";
import { fetchOneDriveDocuments } from "./oneDriveListSlice";
import { deleteOneDriveDocument, deleteOneDriveDocumentsBulk } from "./oneDriveDeleteSlice";
import { fetchOneDriveDownloadUrl, clearOneDriveDownloadUrl, setDownloadDialogOpen } from "./oneDriveDownloadSlice";

// Reducers (for store). Same pattern as documents: use slice default (reducer) like previewInTeamsReducer.
export const oneDriveReducer = oneDriveListSlice;
export const filteredOneDriveReducer = filteredOneDriveSlice.reducer;
export const oneDriveDeleteReducer = oneDriveDeleteSlice;
export { oneDriveDownloadReducer };
export { oneDriveDocsListReducer };

// Slices (default = reducer)
export { default as oneDriveListSlice } from "./oneDriveListSlice";
export { default as filteredOneDriveSlice } from "./filteredOneDriveSlice";
export { default as oneDriveDocsListSlice } from "./oneDriveDocsListSlice";
export { default as oneDriveDeleteSlice } from "./oneDriveDeleteSlice";
export { default as oneDriveDownloadSlice } from "./oneDriveDownloadSlice";

// Thunks (full names, no "on*")
export {
  fetchOneDriveDocuments,
  deleteOneDriveDocument,
  deleteOneDriveDocumentsBulk,
  fetchOneDriveDownloadUrl,
  clearOneDriveDownloadUrl,
  setDownloadDialogOpen,
};

// Managed OneDrive API
export const oneDriveReducers = {
  oneDriveReducer,
  filteredOneDriveReducer,
  oneDriveDocsListReducer,
  oneDriveDeleteReducer,
  oneDriveDownloadReducer,
};

export const oneDriveThunks = {
  fetchOneDriveDocuments,
  deleteOneDriveDocument,
  deleteOneDriveDocumentsBulk,
  fetchOneDriveDownloadUrl,
};
